export default __webpack_public_path__ + "static/mojola-35e60060e6983bfb90c886dd0642c4fd.png";